"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Componente para entrada de texto
 */
var TextInput = function TextInput(_ref) {
  var color = _ref.color,
      disabled = _ref.disabled,
      helperText = _ref.helperText,
      error = _ref.error,
      fullWidth = _ref.fullWidth,
      label = _ref.label,
      id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_core.TextField, {
    color: color,
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    helperText: helperText,
    id: id,
    label: label,
    name: name,
    onChange: onChange,
    required: required,
    variant: "outlined",
    type: "text",
    value: value
  });
};

exports.TextInput = TextInput;
TextInput.propTypes = {
  /**
   * Cor do campo
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,

  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,

  /**
   * Se `true` o campo fica no estado de erro
   */
  error: _propTypes.default.bool,

  /**
   * Propriedade para deixar o campo com largura máxima
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Texto de auxílio de preechimento do campo ou mensagem de erro
   */
  helperText: _propTypes.default.string,

  /**
   * Atributo `id` do componente
   */
  id: _propTypes.default.string,

  /**
   * Label do componente
   */
  label: _propTypes.default.string,

  /**
   * Atributo `name` do input
   */
  name: _propTypes.default.string,

  /**
   * Função executada quando valor é mudado
   */
  onChange: _propTypes.default.func,

  /**
   * Se `true` o campo se mostra como obrigatório
   */
  required: _propTypes.default.bool,

  /**
   * Valor digitado no campo
   */
  value: _propTypes.default.string
};
TextInput.defaultProps = {
  error: false,
  disabled: false,
  fullWidth: false,
  helperText: null,
  id: null,
  label: null,
  name: null,
  onChange: null,
  required: false,
  value: ''
};